import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import LastEdition from "./components/Lastedition";
import Footer from "./components/Footer";
import Main from "./components/Jury/main";
import FloatingButton from "./components/FloatingButton";
import JuryAbout from "./components/Jury/about";
import CTA from "./components/Jury/CTA";
import { isMobile } from "react-device-detect";
import { OtherSection } from "./components/otherSection";
import { ImageSection } from "./components/ImageSection";
import NewAgenda from "./components/NewAgenda";
import { ImageSection2 } from "./components/ImageSection2";
import { NewSection } from "./components/NewSection";
import CarouselSection from "./components/CarousalSection";
import MainLayout from "./components/2026Design/MainLayout";
import ContentPart from "./components/ContentPart";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
{/* <MainLayout /> */}
      <Navigation />

       {/*<Header data={landingPageData.Header} />
      <ContentPart /> */}
    
      
      <Contact data={landingPageData.Contact} />

      
      {/* <LastEdition data={landingPageData.Contact} />
      <CTA />
      <Footer data={landingPageData.Contact} />
      <FloatingButton /> */}
    </div>
  );
};

export default App;
